import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { AmplitudeSearchQueryParams } from '../utils/createAmplitudeSearchQueryParams';

export type TrackSearchRefinedPayload = TrackingPayload &
    AmplitudeSearchQueryParams & {
        normalizedSearchQuery: string;
        numberOfSearchResults: number;
    };

export const trackSearchRefinedAnalytics = (payload: TrackSearchRefinedPayload) => {
    track(TrackingEvents.Search.SearchRefined, payload);
};

export const useTrackSearchRefinedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        (payload: Omit<TrackSearchRefinedPayload, 'pageName' | 'url'>) => {
            trackSearchRefinedAnalytics({
                ...payload,
                normalizedSearchQuery: payload.searchQuery?.toLowerCase() ?? '',
                numberOfSearchResults: payload.numberOfSearchResults,
                pageName: getAmplitudePageNameFromPath(pathname),
                searchQuery: payload.searchQuery,
                url,
            });
        },
        [pathname, url]
    );
};
